import React from 'react';

import './collections-overview.styles.scss';

const CollectionsOverview = () => {
    return (
        <div>
            <h2>Collections Overview Page</h2>
        </div>
    );
}

export default CollectionsOverview;